<template>
  <div class="buy-notice-warper">
    <div class="title pf-medium">
      {{ skuName }}
    </div>
    <div class="notice-container">
      <template v-if="!purchaseType">
        <div
          v-for="(value, key, index) in refData.noticeData"
          :key="index"
          class="notice-item-warper"
        >
          <div class="key pf-medium">{{ key }}</div>
          <div
            v-for="(valueInner, keyInner, indexInner) in value"
            :key="indexInner"
            class="notice-item"
          >
            <p>{{ keyInner }}</p>
            <div
              v-if="valueInner.type === 2 || valueInner.type === undefined"
              class="notice-info"
            >
              <span v-if="valueInner.tag" class="appoint-time">{{
                valueInner.tag
              }}</span>
              {{ valueInner.info }}
            </div>
            <div v-else-if="valueInner.type === 1" class="coupon-warper">
              <CouponItem
                v-for="(str, strIndex) in valueInner.tag"
                :coupon="str"
                class="item"
                :key="strIndex"
              />
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="notice-item-warper">
          <div class="key pf-medium">购买须知</div>
          <div v-for="(value, key) in groupBuyData" :key="value">
            <template v-if="value">
              <div class="notice-item">
                <p>{{ key }}</p>
                <div class="notice-info">{{ value }}</div>
              </div>
            </template>
          </div>
          <div v-for="item in noticeInfo.skuBuyNote || []" :key="item.id">
            <template v-if="item.detailContent">
              <div class="notice-item">
                <p>{{ item.noteTitle }}</p>
                <div v-if="isArray(JSON.parse(item.detailContent || ''))">
                  <div
                    v-for="(itemInner, indexInner) in JSON.parse(
                      item.detailContent
                    )"
                    :key="indexInner"
                    class="text"
                  >
                    {{ indexInner + 1 }}、{{ itemInner }}
                  </div>
                </div>
                <div v-else class="notice-info">{{ item.detailContent }}</div>
              </div>
            </template>
          </div>
        </div>
        <div class="notice-item-warper">
          <div class="key pf-medium">图文详情</div>
          <div class="content" v-html="noticeInfo.content"></div>
        </div>
      </template>
      <div class="store-info">
        <div class="name pf-medium" @click="toStore">
          {{ noticeInfo.businessName }}
        </div>
        <div class="phone" @click="call">
          <img src="@/assets/images/icon_phone.png" />
          <div>联系商家</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNoticeData } from './service'
import CouponItem from './CouponItem.vue'
import { isArray } from 'lodash'
export default {
  components: {
    CouponItem
  },
  data() {
    return {
      isArray
    }
  },
  props: {
    noticeInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    //景点601 是否是团购
    purchaseType: {
      type: Boolean,
      default: false
    },
    skuName: {
      type: String,
      default: ''
    }
  },
  mounted() {
    console.log(this.refData)
  },
  methods: {
    toStore() {
      location.href = `//life.cekid.com/h5/shop?businessId=${this.noticeInfo.businessId}`
    },
    call() {
      location.href = `tel:${this.noticeInfo.mobile}`
    }
  },
  computed: {
    refData() {
      return getNoticeData(this.noticeInfo)
    },
    groupBuyData() {
      return {
        使用期限: this.noticeInfo.useTime || '',
        适用人群: this.noticeInfo.applyPeople || '',
        单人可购: this.noticeInfo.purchaseTimes || '',
        预约说明: this.noticeInfo.scheduleExplain || ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.buy-notice-warper {
  position: relative;
  height: 100%;

  .title {
    height: rem(108px);
    padding-right: rem(80px);
    padding-left: rem(32px);
    @include ellicpsis;
    font-size: rem(32px);
    color: #121212;
    letter-spacing: 0;
    line-height: rem(108px);
    border-bottom: #ededed 1px solid;
  }

  .notice-container {
    padding: 0 rem(32px) rem(50px);

    //head 108
    height: calc(100% - 1.28rem);
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    .notice-item-warper {
      padding-top: rem(48px);
      .key {
        font-size: rem(28px);
        color: #121212;
        line-height: rem(34px);
        margin-bottom: rem(4px);
      }
      .notice-item {
        margin-top: rem(20px);
        display: flex;

        p {
          color: #666666;
          align-self: baseline;
          width: rem(162px);
          line-height: 1.3;
          font-size: rem(26px);
        }
        .notice-info {
          flex: 1;
          position: relative;
          font-size: rem(26px);
          color: #262626;
          line-height: 1.3;
          span {
            position: relative;
            top: -2px;
            font-size: rem(20px);
          }
          .appoint-time {
            border: 1px solid #1cb863;
            border-radius: rem(4px);
            font-size: rem(20px);
            color: #1cb863;
            padding: 0 rem(8px);
          }
        }

        .coupon-warper {
          display: flex;
          flex-wrap: nowrap;
          overflow: hidden;
          overflow-x: scroll;
          width: rem(524px);
          &::-webkit-scrollbar {
            display: none;
          }
          .item {
            margin-right: rem(16px);
          }
        }
      }
    }

    .store-info {
      margin-top: rem(48px);
      display: flex;
      height: rem(64px);
      padding: 0 rem(12px);
      align-items: center;
      background: #f7f8fa;
      border-radius: rem(8px);
      .name {
        font-size: rem(28px);
        flex: 1;
        @include ellicpsis;
        line-height: rem(34px);
        color: #121212;
        background: url('~@/assets/images/icon_store.png') no-repeat;
        background-size: rem(30px) rem(30px);
        padding-left: rem(40px);
      }
      .phone {
        margin-left: rem(20px);
        display: flex;
        align-items: center;
        font-size: rem(24px);
        color: #ff5900;

        img {
          width: rem(32px);
          height: rem(32px);
          margin-right: rem(8px);
        }
      }
    }
  }
}
</style>
